import { AuthProvider as ReactAuthProvider, UserManager } from 'oidc-react';
import { useHistory } from 'react-router-dom';
import { SSO_REDIRECT_URI } from '../constants';

const AuthProvider = ({ children, authenticationUrl }) => {
  const history = useHistory();

  const userManager = new UserManager({
    authority: authenticationUrl,
    client_id: 'customerportal',
    redirect_uri: `${window.location.protocol}//${window.location.host}${SSO_REDIRECT_URI}`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.host}${SSO_REDIRECT_URI}`,
    response_type: 'id_token token',
    scope: 'openid profile portalapi',
    automaticSilentRenew: false, // set to true later if create silent renew page
    monitorSession: false, // do not raise events when user has performed a logout at IdentityServer
    filterProtocolClaims: true, // otherwise allows all the OIDC protocol claims to be returned
    loadUserInfo: false // do not call user info endpoint for an OIDC request when there is an access_token
  });
    
  const onSignIn = async (user) => {

    if (!user.access_token) {
      throw new Error('There was a problem authenticating the current user.');
    }

    history.push('/start');
  };

  return (
    <ReactAuthProvider
      autoSignIn={false}
      userManager={userManager}
      onSignIn={onSignIn}
    >
      {children}
    </ReactAuthProvider>
  );
}

export default AuthProvider;